export const previewModeUrl = process.env.ADMIN_API_URL + "/graphql/affiliate";
export const publicModeUrl = process.env.PUBLIC_API_URL + "/v1/ads-list/";
export const httpStatusName = {
    '200': 'OK',
    '201': 'Created',
    '202': 'Accepted',
    '203': 'Non-Authoritative Information',
    '204': 'No Content',
    '205': 'Reset Content',
    '206': 'Partial Content',
    '300': 'Multiple Choices',
    '301': 'Moved Permanently',
    '302': 'Found',
    '303': 'See Other',
    '304': 'Not Modified',
    '305': 'Use Proxy',
    '306': 'Unused',
    '307': 'Temporary Redirect',
    '400': 'Bad Request',
    '401': 'Unauthorized',
    '402': 'Payment Required',
    '403': 'Forbidden',
    '404': 'Not Found',
    '405': 'Method Not Allowed',
    '406': 'Not Acceptable',
    '407': 'Proxy Authentication Required',
    '408': 'Request Timeout',
    '409': 'Conflict',
    '410': 'Gone',
    '411': 'Length Required',
    '412': 'Precondition Required',
    '413': 'Request Entry Too Large',
    '414': 'Request-URI Too Long',
    '415': 'Unsupported Media Type',
    '416': 'Requested Range Not Satisfiable',
    '417': 'Expectation Failed',
    '418': 'I\'m a teapot',
    '429': 'Too Many Requests',
    '500': 'Internal Server Error',
    '501': 'Not Implemented',
    '502': 'Bad Gateway',
    '503': 'Service Unavailable',
    '504': 'Gateway Timeout',
    '505': 'HTTP Version Not Supported',
};

export function getXRequestID() {
    var xRequestId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    return xRequestId;
}

export function getUserCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while(c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if(c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export function fetchPreviewResult(url) {
    let headerParam = {'access-token' : getUserCookie('jwt'), 'x-request-id' : getXRequestID()};
    return fetchAPIResult(url, headerParam);
}

export function fetchPublicResult(url) {
    let headerParam = {'x-request-id' : getXRequestID()};
    return fetchAPIResult(url, headerParam);
}

export function fetchPublicResult1(url) {
    let headerParam = {'x-request-id' : getXRequestID()};
    return fetchAPIResult1(url, headerParam);
}


export function setGridStyle(showSupplierName, isImageOnly, backgroundColor, titleColor, textColor, type) {
    document.getElementsByTagName('body')[0].style.backgroundColor = backgroundColor;
    if(type ==="supplier" && document.getElementById('supplier-image-group')){
        document.getElementById('supplier-image-group').style.backgroundColor = backgroundColor
    }
    if(document.getElementById('itemName')){
        document.getElementById('itemName').style.color = titleColor;
    }
    document.getElementById('companyName').style.color = textColor;
    if(showSupplierName === "false") {
        document.getElementById("card-footer").style.display = "none";
        if(type === "service"){
            document.getElementById("separation-line").style.display = "none";
        }
        if(type === "supplier"){
            document.getElementById("separation-line").style.display = "none";
            document.getElementById("card-body").style.display = "none";
        }
    }
    if(isImageOnly === "true") {
        document.getElementById('card-body').style.display = "none";
        document.getElementsById('card-footer').style.display = "none";
    }
}

export function displayGridInfo(cardDetail) {
    document.getElementById("itemName").innerHTML = cardDetail.itemName;
    document.getElementById("companyName").innerHTML = cardDetail.companyName;
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    document.getElementById('productImage').src = cardDetail.mediaList[0].url;
    if(cardDetail.companyVerifRank) {
        document.getElementById('companyVerifRank').src = "asset/verified_s_" + cardDetail.companyVerifRank + ".svg";
    }
}

export function displayServiceGridInfo(cardDetail) {
    document.getElementById("itemName").innerHTML = cardDetail.itemName;
    document.getElementById("companyName").innerHTML = cardDetail.companyName;
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    document.getElementById('serviceImage').src = cardDetail.mediaList[0].url;
    if(cardDetail.companyVerifRank) {
        document.getElementById('companyVerifRank').src = "asset/verified_m_" + cardDetail.companyVerifRank + ".svg";
    }
}

export function displaySupplierGridInfo(cardDetail,showSupplierName) {
    document.getElementById("companyName").innerHTML = cardDetail.companyName;
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    cardDetail.mediaList.map((item, index) =>{
        let image_url = item.type ==="VIDEO" && !item.url ? 'asset/placeholder-video-square.svg' : item.url;

        let webp_image_url = item.type ==="VIDEO" && !item.webPSrc ? 'asset/placeholder-video-square.svg' : item.webPSrc;

        document.getElementById("supplier-image-container-"+index).innerHTML = `
        <picture>
            <source type="image/webp" srcset="${webp_image_url}">
            <source type="image/jpeg" srcset="${image_url}">
            <img id="supplierImage${index}" src="${image_url}" class="supplier-image" alt=${item.alt}>
        </picture>`
    });
    document.getElementById("countryName").innerHTML = cardDetail.country || cardDetail.companyCountryRegion || '';
    document.getElementById("natureOfBusinesses").innerHTML = cardDetail.natureOfBusinesses.join(", ");
    if(showSupplierName === "false") {
        if(document.getElementById("supplierImage0")){
            document.getElementById("supplierImage0").style.borderBottomLeftRadius = "7.5px";
        }
        if(document.getElementById("supplierImage2")){
            document.getElementById("supplierImage2").style.borderBottomRightRadius = "7.5px";
        }
    }
    if(cardDetail.companyVerifRank) {
        document.getElementById('companyVerifRank').src = "asset/verified_m_" + cardDetail.companyVerifRank + ".svg";
    }
}

export function setListStyle(showSupplierName, showBorder, backgroundColor, titleColor, textColor) {
    document.getElementsByTagName('body')[0].style.backgroundColor = backgroundColor;
    document.getElementById('itemName').style.color = titleColor;
    document.getElementById('companyName').style.color = textColor;
    if(showSupplierName === "false") {
        document.getElementById('companyName').style.display = "none";
        document.getElementById("companyVerifRank").style.visibility = "hidden";
    }
    if(showBorder === "false") {
        document.getElementById('product-detail').style.boxShadow = "none";
        document.getElementById('product-detail').style.border = "none";
    }
}

export function displayListInfo(cardDetail) {
    document.getElementById("itemName").innerHTML = cardDetail.itemName;
    document.getElementById("companyName").innerHTML = cardDetail.companyName;
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    document.getElementById('productImage').src = cardDetail.mediaList[0].url;
    if(cardDetail.companyVerifRank) {
        document.getElementById('companyVerifRank').src = "asset/verified_l_" + cardDetail.companyVerifRank + ".svg";
    }
    if(cardDetail.mediaList.length < 2) {
        document.getElementById('sub-images').style.display = "none";
    } else {
        let subImages = cardDetail.mediaList.slice(1).map((subImage) => (subImage.type == "IMAGE")? subImage.url: "asset/placeholder-video-square.svg" );
        document.getElementById("sub-images").innerHTML = subImages.map(subImage => `<div class="col-6 sub-image p-0"><img src=${subImage} alt="..."/></div>`).join('');
    }
}

export function setGridImageStyle(backgroundColor, showBorder) {
    document.getElementsByTagName('body')[0].style.backgroundColor = backgroundColor;
    if(showBorder === "false") {
	    document.getElementById('card').style.boxShadow = "none";
    }
}

export function displayGridImageInfo(cardDetail) {
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    document.getElementById('productImage').src = cardDetail.mediaList[0].url;
}

export function displayServiceGridImageInfo(cardDetail) {
    document.getElementById('linkUrl').href = cardDetail.linkUrl;
    document.getElementById('serviceImage').src = cardDetail.mediaList[0].url;
}

function fetchAPIResult(url, headerParam) {
	return fetch(url, {
        headers: headerParam
	}).then(response => {
		if (response.ok) {
			return response.json(); 
		}
		return Promise.reject(new Error((httpStatusName[response.status])));
  
	}).catch(error => {
		console.log('Request failed:', error.message);
		throw error;
	});
}

function fetchAPIResult1(url, headerParam) {
	return fetch(url, {
        headers: headerParam
	}).then(response => {
		if (response.ok) {
			return response.json(); 
		}
		return Promise.reject(new Error((httpStatusName[response.status])));
  
	})
}